<template>
  <div class="product-info-description html-content">
    <h2>Описание</h2>
    <div v-html="PRODUCT.description"/>
    <div v-html="material"/>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'about',

    computed: {
      ...mapGetters({
        PRODUCT: 'product/item',
      }),

      material() {
        return this.PRODUCT.material ? '<h4>Состав</h4>' + this.PRODUCT.material : '';
      }
    }
  }
</script>